import React, { useMemo } from 'react';
import { Card } from '@folio/stripes/components';
import classNames from 'classnames';
import { useField } from 'react-final-form';
import css from '../Card.module.css';
import TokenCardToolbox from './TokenCardToolbox';
import LengthControlDrawer from './LengthControlDrawer';
export default function GenericTokenCard(_a) {
    var _b, _c;
    var fieldArrayName = _a.fieldArrayName, name = _a.name, index = _a.index, isLast = _a.isLast, SelectComponent = _a.SelectComponent, BodyComponent = _a.BodyComponent, isBodyEmpty = _a.isBodyEmpty, shouldHaveLengthControl = _a.shouldHaveLengthControl;
    var type = useField("".concat(name, ".type"), {
        subscription: { value: true },
        // preserve undefined
        format: function (value) { return value; },
    }).input.value;
    // cache this since we use it multiple times
    var lengthControlAvailable = useMemo(function () { return shouldHaveLengthControl(type); }, [type, shouldHaveLengthControl]);
    var lengthControlOpen = useField("".concat(name, ".lengthControl.drawerOpen"), {
        subscription: { value: true },
        format: function (value) { return value !== null && value !== void 0 ? value : false; },
    }).input.value;
    return (React.createElement(React.Fragment, null,
        React.createElement(Card, { cardClass: classNames(css.cardClass, (_b = {},
                _b[css.cardWithLengthControl] = lengthControlAvailable && lengthControlOpen,
                _b)), headerClass: css.headerClass, headerStart: React.createElement(SelectComponent, { name: "".concat(name, ".type") }), headerEnd: React.createElement(TokenCardToolbox, { fieldArrayName: fieldArrayName, name: name, index: index, isLast: isLast, showLengthControl: lengthControlAvailable }), bodyClass: classNames((_c = {},
                _c[css.emptyBody] = isBodyEmpty(type),
                _c)) },
            React.createElement(BodyComponent, { name: name })),
        lengthControlAvailable && lengthControlOpen && React.createElement(LengthControlDrawer, { prefix: "".concat(name, ".lengthControl.") })));
}
